import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EditStateService {
 public isEditing: WritableSignal<boolean> = signal(false);

  constructor() { }

  toggleEditState(): void {
    this.isEditing.set(!this.isEditing());
  }
}
